export default "__VITE_ASSET__D_QvtF_s__"